/** @typedef {{ itemName: string, qty: number, tranDate: string, monthKey: string, year: number, month: number, branchId: string, branchName: string }} SalesRecord */

export function normalizeItemKey(name) {
  return String(name ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

export function itemNameFromRow(row) {
  return String(
    row?.itemName ?? row?.["Item Name"] ?? row?.ItemName ?? row?.desc ?? row?.partNo ?? ""
  ).trim();
}

export function qtyFromRow(row) {
  const q = Number(row?.qty ?? row?.Qty ?? 0);
  return Number.isFinite(q) ? Math.abs(q) : 0;
}

/** @returns {SalesRecord | null} */
export function rowToSalesRecord(row) {
  const itemName = itemNameFromRow(row);
  if (!itemName) return null;

  const tranDate = String(row?.tranDate ?? row?.["Trans Date"] ?? "").slice(0, 10);
  if (!tranDate || tranDate.length < 7) return null;

  const [yStr, mStr] = tranDate.split("-");
  const year = Number(yStr);
  const month = Number(mStr);
  if (!year || !month) return null;

  const qty = qtyFromRow(row);
  if (!qty) return null;

  const branchId = String(row?.branchId ?? row?.BranchID ?? "").trim();
  const branchName = String(row?.branchName ?? row?.BranchName ?? "").trim();

  return {
    itemName,
    qty,
    tranDate,
    monthKey: `${year}-${String(month).padStart(2, "0")}`,
    year,
    month,
    branchId,
    branchName,
  };
}
